/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deep_Match_Keyword_CoverageInputs */

const en_deep_match_keyword_coverage = /** @type {(inputs: Deep_Match_Keyword_CoverageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword Coverage`)
};

const de_deep_match_keyword_coverage = /** @type {(inputs: Deep_Match_Keyword_CoverageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword Coverage`)
};

const fr_deep_match_keyword_coverage = /** @type {(inputs: Deep_Match_Keyword_CoverageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword Coverage`)
};

const es_deep_match_keyword_coverage = /** @type {(inputs: Deep_Match_Keyword_CoverageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword Coverage`)
};

const it_deep_match_keyword_coverage = /** @type {(inputs: Deep_Match_Keyword_CoverageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword Coverage`)
};

const nl_deep_match_keyword_coverage = /** @type {(inputs: Deep_Match_Keyword_CoverageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword Coverage`)
};

const pl_deep_match_keyword_coverage = /** @type {(inputs: Deep_Match_Keyword_CoverageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword Coverage`)
};

const fi_deep_match_keyword_coverage = /** @type {(inputs: Deep_Match_Keyword_CoverageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword Coverage`)
};

const da_deep_match_keyword_coverage = /** @type {(inputs: Deep_Match_Keyword_CoverageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword Coverage`)
};

const sv_deep_match_keyword_coverage = /** @type {(inputs: Deep_Match_Keyword_CoverageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword Coverage`)
};

/**
* | output |
* | --- |
* | "Keyword Coverage" |
*
* @param {Deep_Match_Keyword_CoverageInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const deep_match_keyword_coverage = /** @type {((inputs?: Deep_Match_Keyword_CoverageInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deep_Match_Keyword_CoverageInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_deep_match_keyword_coverage(inputs)
	if (locale === "fr") return fr_deep_match_keyword_coverage(inputs)
	if (locale === "es") return es_deep_match_keyword_coverage(inputs)
	if (locale === "it") return it_deep_match_keyword_coverage(inputs)
	if (locale === "nl") return nl_deep_match_keyword_coverage(inputs)
	if (locale === "pl") return pl_deep_match_keyword_coverage(inputs)
	if (locale === "fi") return fi_deep_match_keyword_coverage(inputs)
	if (locale === "da") return da_deep_match_keyword_coverage(inputs)
	if (locale === "sv") return sv_deep_match_keyword_coverage(inputs)
	return en_deep_match_keyword_coverage(inputs)
});